import { useState } from "react";
import DepartmentAdd from "../components/DepartmentAdd";
import DepartmentList from "../components/DepartmentList";
import Footer from "../components/Footer";
import Startbar from "../components/Startbar";
import Topbar from "../components/Topbar";

const User = () => {
  const [refreshKey, setRefreshKey] = useState(0); // 🔁 trigger for reload
  return (
    <>
      <Topbar />
      <Startbar />
      <div className="page-wrapper">
        <div className="page-content">
          <div className="container-xxl">
            <div className="row justify-content-center">
              <div className="col-md-6 col-lg-6">
                <div className="card">
                  <div className="card-body">
                    <DepartmentAdd
                      onDepartmentAdded={() =>
                        setRefreshKey((prev) => prev + 1)
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-6">
                <div className="card">
                  <div className="card-body">
                    <DepartmentList refreshKey={refreshKey} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default User;
